import React from 'react';
import styles from './LoadingSpinner.module.css';
import {loadingLottie} from '../../assets/lottie';
import Lottie from 'lottie-react';
import {Icon} from '../Icon/Icon';

interface LoadingSpinnerProps {
  size?: number;
  /**
   * A spinning ring in the text colour that sits in a line of text, a button
   * or a badge, instead of the centred animation.
   */
  inline?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 34,
  inline = false,
}) => {
  if (inline)
    return (
      <span
        className={styles.inline}
        style={{fontSize: `${size}px`}}
        aria-hidden="true">
        <Icon name="studio-loader.svg" className={styles.spin} />
      </span>
    );

  return (
    <div className={styles.wrapper}>
      <Lottie
        animationData={loadingLottie}
        loop={true}
        style={{width: `${size}px`, height: `${size}px`}}
      />
    </div>
  );
};

export default LoadingSpinner;
